<div class="form-group row">
  <div class="col-form-label col-sm-6 text-sm-right">
    <label [for]="name"><ng-content select="[form-label]"></ng-content></label>
    <help-text-trigger [for]="name + '-help'" *ngIf="help"></help-text-trigger>
  </div>
  <div class="col-sm-6">
    <ng-content select="[form-control]"></ng-content>
    <div class="invalid-feedback" [mas-validation-message]="control"></div>
  </div>
</div>
<help-text-content [id]="name + '-help'" *ngIf="help">
  <ng-content select="[form-help]"></ng-content>
</help-text-content>
